import { render, staticRenderFns } from "./additionalInfo.vue?vue&type=template&id=feae2a52&scoped=true&"
import script from "./additionalInfo.vue?vue&type=script&lang=js&"
export * from "./additionalInfo.vue?vue&type=script&lang=js&"
import style0 from "./additionalInfo.vue?vue&type=style&index=0&id=feae2a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feae2a52",
  null
  
)

export default component.exports